import {Locale} from '@aboutyou/config';
import {useLocale} from '@aboutyou/i18n';

export const useWebCouponDeviceImage = () => {
  const locale = useLocale();

  switch (locale) {
    case Locale.de_DE:
    case Locale.de_CH:
    case Locale.de_AT:
      return 'https://cdn.aboutstatic.com/file/images/271d92e738c2cd8ba15d300b8f416bd2.png?transparent=1';
    default:
      return 'https://cdn.aboutstatic.com/file/images/184c525b331a14d575c94b47a3df189e.png?transparent=1';
  }
};
